import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BV, formatVP } from '../../../helpers/helperFunctions';
import { ArrowPolygon } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { FlexCenterEqual, VolumesInfo } from '../MyTeamBackofficeStyled';
import {
  ExpandedDiv,
  Level,
  LevelExpanded,
  LevelTitle
} from './VolumePointsStyled';

const Week = ({ week, isCurrentWeek }) => {
  const { t } = useTranslation('myTeam');
  const [expand, setExpand] = useState(false);
  return (
    <>
      <Level
        onClick={() => setExpand(expand === 1 ? '' : 1)}
        expand={expand === 1}
        isCurrentWeek={isCurrentWeek}>
        <div>
          <LevelTitle>
            {moment(week.weekStartDate).format('DD MMM')} {' - '}
            {moment(week.weekEndDate).format('DD MMM YY')}
          </LevelTitle>
        </div>

        <ArrowPolygon
          customColor={color.colors.neutral50}
          direction={expand === 1 ? 'down' : 'right'}
        />
      </Level>
      <LevelExpanded expand={expand === 1}>
        <ExpandedDiv>
          <VolumesInfo>
            <h1>{t('volume_points_page.initial_balance')}</h1>
            <FlexCenterEqual>
              <div>
                <h2>
                  {t('volume_points_page.left')} {BV}
                </h2>

                <h3>{formatVP(week.startLeftLegVolume)} </h3>
              </div>
              <div>
                <h2>
                  {t('volume_points_page.right')} {BV}
                </h2>
                <h3>{formatVP(week.startRightLegVolume)}</h3>
              </div>
            </FlexCenterEqual>
          </VolumesInfo>
          <VolumesInfo>
            <h1>{t('volume_points_page.new_balance')}</h1>
            <FlexCenterEqual>
              <div>
                <h2>
                  {t('volume_points_page.left')} {BV}
                </h2>
                <h3>{formatVP(week.newLeftLegVolume)}</h3>
              </div>
              <div>
                <h2>
                  {t('volume_points_page.right')} {BV}
                </h2>
                <h3>{formatVP(week.newRightLegVolume)}</h3>
              </div>
            </FlexCenterEqual>
          </VolumesInfo>
        </ExpandedDiv>
      </LevelExpanded>
    </>
  );
};

export default Week;
